import React from 'react'
import GuestTouChart from './GuestTouChart'

const getOutletOptions = (powerType) => ({
    L1: 1.9,
    L2: powerType === '3P-208' ? 3.3 : 3.8,
})

const OutletSelectionCard = ({
    costData,
    costLoading,
    costError,
    powerType,
    selectedOutlet,
    onOutletChange,
    onConfirm,
    onCancel,
}) => {
    const outletOptions = getOutletOptions(powerType)
    return (
    <div className="gc-card">
        <h1 className="gc-page-title">Select outlet type</h1>
        <p className="gc-page-sub">
            Review pricing below, select your outlet type, then confirm to start charging.
        </p>

        <div className="gc-section-h">Charging rates</div>
        <div
            className="gc-rates-table"
            role="table"
            aria-label="Available outlet types"
            style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}
        >
            {Object.entries(outletOptions).map(([label, kw]) => {
                const isActive = label === selectedOutlet
                return (
                    <button
                        key={label}
                        type="button"
                        className={`gc-rate-cell${isActive ? ' is-active' : ''}`}
                        role="cell"
                        onClick={() => onOutletChange && onOutletChange(label)}
                        aria-pressed={isActive}
                    >
                        <div className="gc-rate-label">{label}</div>
                        <div className="gc-rate-value">
                            <span className="num">{kw}</span>
                            <span className="unit">kW</span>
                        </div>
                    </button>
                )
            })}
        </div>

        <div className="gc-section-h">Today's rates</div>
        <GuestTouChart costData={costData} powerType={selectedOutlet} useUpCharge />
        {costLoading && (
            <div style={{ font: 'var(--gp-caption)', color: 'var(--gp-ink-mute)', textAlign: 'center', padding: '12px 0' }}>
                Loading rates…
            </div>
        )}
        {costError && (
            <div style={{ font: 'var(--gp-caption)', color: 'var(--gp-danger)', textAlign: 'center', padding: '12px 0' }}>
                Couldn't load today's rates.
            </div>
        )}

        <p className="gc-foot">
            Rates shown for the current property.
            <br />
            By starting a session you agree to the rates above.
        </p>

        <div className="gc-confirm-row" style={{ marginTop: 16 }}>
            <button type="button" className="gc-btn gc-btn-secondary" onClick={onCancel}>
                Cancel
            </button>
            <button type="button" className="gc-btn gc-btn-primary" onClick={onConfirm}>
                Confirm {selectedOutlet}
            </button>
        </div>
    </div>
    )
}

export default OutletSelectionCard
